import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./Navbar.css";
import "./PlanNavbar.css";
import { GetCurrentPlan } from "../../services/MyProfileApi";

function PlanNavbar() {
  const [planData, setPlanData] = useState(null);
  const [remainingDays, setRemainingDays] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPlanDetails();
  }, []);

  async function fetchPlanDetails() {
    const response = await GetCurrentPlan();
    if (response?.data?.end_date) {
      calculateRemainingDays(response.data.end_date);
      setPlanData(response.data);
    }
  }

  function calculateRemainingDays(endDate) {
    const today = new Date();
    const end = new Date(endDate);
    const diffMs = end - today;
    const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    setRemainingDays(days);
  }

  // 👇 Hide PlanNavbar if plan has more than 10 days left
  if (remainingDays !== null && remainingDays >= 10) {
    return null;
  }

  return (
    <div className="plan-navbar">
      <div className="plan-sub-navbar">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_12649_9146)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.10592 0.258324C7.37512 0.0937686 7.68452 0.0066967 8.00003 0.0066967C8.31553 0.0066967 8.62492 0.0937686 8.89412 0.258324C9.16332 0.422879 9.38188 0.658533 9.52574 0.939336L9.52829 0.944321L15.8131 13.5142C15.9443 13.7749 16.0073 14.0657 15.9951 14.3574C15.9828 14.6494 15.8962 14.9334 15.7433 15.1824C15.5904 15.4314 15.3764 15.6373 15.1216 15.7803C14.8668 15.9234 14.5796 15.999 14.2874 15.9999H14.2857H1.71431H1.71257C1.42036 15.999 1.13321 15.9234 0.878405 15.7803C0.623605 15.6373 0.40961 15.4314 0.256742 15.1824C0.103875 14.9334 0.0172116 14.6494 0.00498129 14.3574C-0.00723477 14.0657 0.0552139 13.7758 0.186402 13.5151L6.47177 0.944334L6.47428 0.939324C6.61813 0.65852 6.83673 0.422879 7.10592 0.258324ZM7.99999 4.71429C8.47337 4.71429 8.85713 5.09805 8.85713 5.57143V9.28571C8.85713 9.7591 8.47337 10.1429 7.99999 10.1429C7.52661 10.1429 7.14285 9.7591 7.14285 9.28571V5.57143C7.14285 5.09805 7.52661 4.71429 7.99999 4.71429ZM9.14285 12.4286C9.14285 13.0598 8.63117 13.5714 7.99999 13.5714C7.36881 13.5714 6.85713 13.0598 6.85713 12.4286C6.85713 11.7974 7.36881 11.2857 7.99999 11.2857C8.63117 11.2857 9.14285 11.7974 9.14285 12.4286Z"
              fill="#D9002F"
            />
          </g>
          <defs>
            <clipPath id="clip0_12649_9146">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <div className="text-content">
          {remainingDays > 0 ? (
            <>
              <span className="common-text ftw-5 ">
                {planData?.display_name} ends in{" "}
              </span>
              <span className="expiry-status"> {remainingDays}</span>
              <span className="common-text ftw-5 "> days</span>
            </>
          ) : remainingDays === 0 ? (
            <span className="common-text ftw-7 fts-18 red" style={{ textTransform: "capitalize" }}>
              {planData?.display_name} expires today
            </span>
          ) : (
            <span
              className="expiry-status"
              style={{ textTransform: "capitalize" }}
            >
              {planData?.display_name} Expired
            </span>
          )}
          <button
            className="upgrade-now "
            onClick={() =>
              navigate("/my-profile", { state: { openPlanTab: true } })
            }
          >
            Upgrade now
          </button>
        </div>
      </div>
    </div>
  );
}

export default PlanNavbar;
